import { color } from "chart.js/helpers";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";

const ThankYou = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Booking Confirmed | Customer Supports 24x7</title>
        <meta
          name="description"
          content="Customer Supports 24x7 offers fast mobile and appliance repair services in Bangalore. Trusted doorstep repair for mobiles, washing machines, refrigerators, ACs and more."
        />
        <meta
          name="keywords"
          content="mobile repair Bangalore, appliance repair Bangalore, washing machine repair Bangalore, refrigerator repair Bangalore, AC repair Bangalore, doorstep repair service, Customer Supports 24x7"
        />
        <meta property="og:title" content="Booking Confirmed | Customer Supports 24x7" />
        <meta
          property="og:description"
          content="Customer Supports 24x7 offers fast mobile and appliance repair services in Bangalore. Trusted doorstep repair for mobiles, washing machines, refrigerators, ACs and more."
        />
        <meta property="og:image" content="https://customersupports24x7.in/customerSupport.png" />
        <meta property="og:url" content="https://customersupports24x7.in/thank-you" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Booking Confirmed | Customer Supports 24x7" />
        <meta
          name="twitter:description"
          content="Customer Supports 24x7 offers fast mobile and appliance repair services in Bangalore. Trusted doorstep repair for mobiles, washing machines, refrigerators, ACs and more."
        />
        <meta name="twitter:image" content="https://customersupports24x7.in/customerSupport.png" />
        <link rel="canonical" href="https://customersupports24x7.in/thank-you" />
      </Helmet>
    <div style={styles.container}>
      <div style={styles.card}>

        <div style={styles.icon}>✅</div>

        <h1 style={styles.title}>Thank You!</h1>

        <h2 style={{ color: "#16a34a", marginBottom: "10px" }}>
          Your Order is Confirmed ✅
        </h2>

        <p style={styles.subtitle}>
          🎉 Your Service Booking is Successful!
        </p>

    

        <button style={styles.button} onClick={() => navigate("/")}>
          Go to Home
        </button>

      </div>
    </div>
    </>
  );
};

const styles = {
  container: {
    background: "linear-gradient(to right, #eef2ff, #f8fafc)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "400px",
    width: "90%",
  },
  icon: {
    fontSize: "50px",
    marginBottom: "10px",
  },
  title: {
    color: "#16a34a",
    marginBottom: "10px",
  },
  subtitle: {
    color: "#4b5563",
    marginBottom: "20px",
  },
  details: {
    background: "#f1f5f9",
    padding: "15px",
    borderRadius: "10px",
    marginBottom: "20px",
    textAlign: "left",
  },
  button: {
    background: "#16a34a",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default ThankYou;
